// This is a part of the Cadcorp SIS source code. 
// Copyright (c) Cadcorp Limited 1991-2025 
import { openDB } from 'idb';

const objectStores_version = {
    bookmark: 1,
    settings: 2
};

const LATEST_DB_VERSION = Math.max(...Object.values(objectStores_version));

export function createLocalStorage(name: string): void {
    openDB(name, LATEST_DB_VERSION, {
        upgrade(db, oldVersion, newVersion, transaction) {
            if (oldVersion < objectStores_version.bookmark)
                if (!db.objectStoreNames.contains('bookmark'))
                    db.createObjectStore('bookmark', { keyPath: 'id', autoIncrement: true });

            if (oldVersion < objectStores_version.settings)
                if (!db.objectStoreNames.contains('settings'))
                    db.createObjectStore('settings');
        }
    })
    .then((db) => db.close())
    .catch((eventArgs) => console.log(`error opening ${name} db ${eventArgs}`));
}

